<template>
<v-list-tile @click='$emit("selected", item)'
  :key='item.id' >
  <v-list-tile-action class='hidden-xs-only' >
    <v-icon :title='transport' >{{transport}}</v-icon>
  </v-list-tile-action>
  <v-list-tile-content>
    <v-list-tile-sub-title >
      <strong>to:</strong>
      <template v-for='recipient in item.recipient_emails' v-if='transport === "email"' >
        <v-chip label small outline
          :key='recipient'
          color='primary' class='v-chip--x-small' >{{recipient}}</v-chip>
      </template>
      <v-chip small outline label
        v-if='transport === "sms" && item.recipient_phone_number'
        color='primary' class='v-chip--x-small' >{{item.recipient_phone_number}}</v-chip>
    </v-list-tile-sub-title>
    <v-list-tile-sub-title class='caption' v-text="title" />
    <v-list-tile-sub-title class='caption' >
      <strong>Sent: {{ dateformat(item.created_date, 'ddd DD MMM YYYY H:mma') }} via {{transport}}</strong>
      <!-- <v-chip class='visible-xs-only v-chip--x-small' >
        {{transport}}
      </v-chip>
      <v-chip
        v-if='item.communicationstatus && item.communicationstatus.length > 0'
        class='visible-xs-only v-chip--x-small' >{{item.communicationstatus[item.communicationstatus.length - 1].status}}
      </v-chip> -->
    </v-list-tile-sub-title>
  </v-list-tile-content>
  <v-list-tile-action class='hidden-xs-only' v-if='item.communicationstatus && item.communicationstatus.length > 0' >
    <v-menu >
      <template v-slot:activator="{ on }">
      <v-btn v-on='on' slot='activator' flat small >
        {{ item.communicationstatus[item.communicationstatus.length - 1].status }}
        <v-icon>expand_more</v-icon>
      </v-btn>
      </template>
      <v-list dense>
        <v-list-tile
          v-for='status in item.communicationstatus'
          :key='status.id' >
          <v-list-tile-content >
            <v-list-tile-title>{{ status.status.toLowerCase() }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ dateformat(status.created_date, 'ddd DD MMM YYYY H:mm a') }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-list-tile-action>
  <!-- <pre v-text="item" class="caption" /> -->
</v-list-tile>
</template>
<script>
const EMAIL_BACKEND = 'services.backends.email.EmailBackend'
const SMS_BACKEND = 'services.backends.zoomconnect.ZoomSMSBackend'
export default {
  name: 'CommunicationListItem',
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    transport () {
      if (this.item.backend_used === EMAIL_BACKEND) { return 'email' }
      if (this.item.backend_used === SMS_BACKEND) { return 'sms' }
    },
    title () {
      if (this.item.backend_used === EMAIL_BACKEND) { return this.item.subject }
      if (this.item.backend_used === SMS_BACKEND) { return this.item.short_message }
      return this.item.subject
    },
    subtitle () {
      return this.item.message
    }
  }
}
</script>



// WEBPACK FOOTER //
// CommunicationListItem.vue?4424f178